import React, { useState } from 'react';
import HelpIcon from '@material-ui/icons/Help';
import './Style.css';
import Backdrop from '../../../Modals/Backdrop';
import { OrderDetails } from '../..';

// import { OrderDetails } from '../..';
const Index = () => {
    const [showdetails, setShowdetails] = useState(false);
    return (
        <>
            {/* <OrderDetails
                state={showdetails}
                setStateFalse={() => {
                    setShowdetails((prev) => !prev);
                }}
            /> */}
            <div
                style={{
                    overflowY: 'hidden',
                    overflowX: 'auto',
                    padding: '1rem',
                }}
            >
                <table className="manageorder_table">
                    <thead className="manageorder_table_head">
                        <tr className="manageorder_table_head_row">
                            <td className="manageorder_table_head_data">Channel</td>
                            <td className="manageorder_table_head_data">Order ID</td>
                            <td className="manageorder_table_head_data">Order Date</td>
                            <td className="manageorder_table_head_data">Status</td>
                            <td className="manageorder_table_head_data">Products</td>
                            <td className="manageorder_table_head_data">Amount</td>
                            <td className="manageorder_table_head_data">Payment </td>
                            <td className="manageorder_table_head_data">Customer </td>
                            <td className="manageorder_table_head_data">Courier Name</td>
                            <td className="manageorder_table_head_data">Tracking ID</td>
                        </tr>
                    </thead>
                    <tbody className="manageorder_table_body">
                        <Component
                            // clickhandler={() => {
                            //     setShowdetails((prev) => !prev);
                            // }}
                            id="ANA98MM1001MM"
                            customer="Jonas Scheman"
                            trackingId="788826691002"
                            status="processing"
                            products={[{ name: 'Butter Yellow Men Round T Shirt', price: 183.75, quantity: 2 }]}
                            qty={1}
                            color="#000000"
                            paymentMethod="Online"
                            courierName="Super Express"
                            datePlaced="02/04/21"
                        />
                        <Component
                            // clickhandler={() => {
                            //     setShowdetails((prev) => !prev);
                            // }}
                            id="ANA98MM1001MM"
                            customer="Jonas Scheman"
                            trackingId="788826691002"
                            status="ready to Dispatched"
                            products={[{ name: 'Butter Yellow Men Round T Shirt', price: 183.75, quantity: 2 }]}
                            qty={1}
                            color="rgba(255, 179, 0, 1)"
                            paymentMethod="Online"
                            courierName="Super Express"
                            datePlaced="02/04/21"
                        />
                        <Component
                            // clickhandler={() => {
                            //     setShowdetails((prev) => !prev);
                            // }}
                            id="ANA98MM1001MM"
                            customer="Jonas Scheman"
                            trackingId="788826691002"
                            status="Dispatched"
                            products={[{ name: 'Butter Yellow Men Round T Shirt', price: 183.75, quantity: 2 }]}
                            qty={1}
                            color="rgba(255, 207, 231, 1)"
                            paymentMethod="Online"
                            courierName="Super Express"
                            datePlaced="02/04/21"
                        />
                        <Component
                            // clickhandler={() => {
                            //     setShowdetails((prev) => !prev);
                            // }}
                            id="ANA98MM1001MM"
                            customer="Jonas Scheman"
                            trackingId="788826691002"
                            status="On hold"
                            products={[{ name: 'Butter Yellow Men Round T Shirt', price: 183.75, quantity: 2 }]}
                            qty={1}
                            color="rgba(175, 175, 175, 1)"
                            paymentMethod="Online"
                            courierName="Super Express"
                            datePlaced="02/04/21"
                        />
                        <Component
                            // clickhandler={() => {
                            //     setShowdetails((prev) => !prev);
                            // }}
                            id="ANA98MM1001MM"
                            customer="Jonas Scheman"
                            trackingId="788826691002"
                            status="Cancelled"
                            products={[{ name: 'Butter Yellow Men Round T Shirt', price: 183.75, quantity: 2 }]}
                            qty={1}
                            color="rgba(206, 5, 31, 1)"
                            paymentMethod="Online"
                            courierName="Super Express"
                            datePlaced="02/04/21"
                        />
                        <Component
                            // clickhandler={() => {
                            //     setShowdetails((prev) => !prev);
                            // }}
                            id="ANA98MM1001MM"
                            customer="Jonas Scheman"
                            trackingId="788826691002"
                            status="Return"
                            products={[{ name: 'Butter Yellow Men Round T Shirt', price: 183.75, quantity: 2 }]}
                            qty={1}
                            color="rgba(16, 28, 134, 1)"
                            paymentMethod="Online"
                            courierName="Super Express"
                            datePlaced="02/04/21"
                        />
                    </tbody>
                </table>
            </div>
        </>
    );
};

const Component = ({ id, status, products, paymentMethod, customer, trackingId, courierName, datePlaced }) => {
    ////Showing All Products
    const [show, setshow] = useState(false);
    const [modal, setModal] = useState(false);
    return (
        <>
            {show && (
                <Backdrop
                    close={() => {
                        setshow((prev) => !prev);
                    }}
                />
            )}
            <OrderDetails
                type="merchant"
                state={modal}
                setStateFalse={() => {
                    setModal(false);
                }}
            />
            <tr
                onClick={() => {
                    setModal(true);
                }}
                className="manageorder_table_body_row"
            >
                <td className="manageorder_table_body_data">WebSite</td>

                <td className="manageorder_table_body_data">Order_{id}</td>
                <td className="manageorder_table_body_data">{datePlaced}</td>
                <td className="manageorder_table_body_data">
                    <div className="manageorder_table_body_change">
                        <p className={`circle ${status.replace(/\s/g, '')}`}></p>
                        <span>{status}</span>
                    </div>
                </td>
                <td className="manageorder_table_body_data">
                    <div style={{ position: 'relative', display: 'flex' }}>
                        <p>{products[0].name.slice(0, 12)}...</p>
                        <HelpIcon
                            onClick={() => {
                                setshow((prev) => !prev);
                            }}
                            className="icon"
                        />

                        <p className={`product_details ${show ? 'show' : ''}`}>
                            {products.map((ele) => (
                                <p key={ele.name}>
                                    {ele.name} X {ele.quantity}
                                </p>
                            ))}
                        </p>
                    </div>
                </td>
                <td className="manageorder_table_body_data">
                    ₹ {products.reduce((prev, curr) => prev + curr.quantity * curr.price, 0)}
                </td>

                <td className="manageorder_table_body_data">{paymentMethod}</td>
                <td className="manageorder_table_body_data">{customer}</td>
                <td className="manageorder_table_body_data">{courierName}</td>
                <td className="manageorder_table_body_data">{trackingId}</td>
            </tr>
        </>
    );
};

export default Index;
